/* global angular */
( function () {
	'use strict';

	function reportSelect ( ) {
		return {
			'templateUrl' : '/templates/report/report-components/report-select/report-select.html',
			'restrict'    : 'E',
			'replace'     : true,
			'scope'       : {
				'reportTitle'  : '@',
				'model'        : '=',
				'display'      : '@',
				'key'          : '@',
				'onAdd'        : '&',
				'onSearch'     : '&',
				'placeHolder'  : '@',
				'changeFilter' : '=',
				'removeTag'    : '=',
				'parentFilter' : '@',
				'childFilter'  : '@',
				'limit'        : '='
			}
		};
	}

	angular
		.module( 'app.report' )
		.directive( 'reportSelect', reportSelect );
} )( );
